import React, { useContext } from "react";
import { Caption, ResourceList, Stack, TextStyle } from "@shopify/polaris";

import constant from "lib/constant/constant";

// import context
import { PrivateContext } from "lib/context";
import { AdvanceShippingContext } from "app/shipping/modules/provider/features/subFeatures/advance/context/context";

// import component
import Actions from "./action";

// import propType
import { ruleItemProp } from "./props";
import { baseHelper } from "lib/helpers";

const RuleItem = (props) => {
  const { isVendorAllowed } = useContext(AdvanceShippingContext);
  const { currentUser = {}, cms } = useContext(PrivateContext);
  const { moneyFormat, item = {}, band = [], destinations = [], products = [], editModal, deleteModal } = props || {};
  const {
    id,
    shippingBandId,
    price,
    description,
    condition,
    destinationCode,
    provinceCode,
    productId,
    priceType,
    isShippingDisabled,
    createdAt,
    updatedAt,
  } = item;
  const isDestination = condition === constant.DESTINATION;
  const isProduct = condition === constant.PRODUCT;

  if (item.condition === null) return null;
  const shippingBand =
    (band.length > 0 && band.find((key) => key.value === shippingBandId || key.parentId === shippingBandId)) || false;

  const countryCode =
    destinationCode && destinationCode.includes("-") ? destinationCode.split("-")[0] : destinationCode;
  const provinceCodeValue =
    provinceCode ?? (destinationCode && destinationCode.includes("-") ? destinationCode.split("-")[1] : null);
  const { options: countries = [] } =
    destinations.find(
      (region) => region && region.options && region.options.find((option) => option.value === countryCode)
    ) || {};
  const destination = countries.find((country) => country.value === countryCode);
  const province =
    provinceCodeValue && destination && destination.states
      ? destination.states.find((s) => s.value === provinceCodeValue)
      : null;
  const product = products.find((pItem) => pItem.value === productId);
  const isFreeOption = priceType === constant.FREE;
  const priceTypeText = isFreeOption ? cms("label.free") : cms("label.fixed");

  const { _id: currentUserId = null } = currentUser || {};
  const { userId: ruleCreatedBy = null } = item || {};
  const shortcutActions = [
    {
      content: cms("button.edit"),
      onAction: () => editModal(item),
      disabled: !isVendorAllowed,
    },
    {
      content: cms("button.delete"),
      destructive: true,
      onAction: () => deleteModal(item),
      disabled: !isVendorAllowed || ruleCreatedBy !== currentUserId,
    },
  ];

  return (
    <ResourceList.Item id={id} accessibilityLabel={`${cms("label.viewDetails")} `}>
      <div className="custom-wrapper">
        <Stack alignment="leading">
          <Stack.Item fill>
            <TextStyle variation="strong">{(shippingBand && shippingBand.label) || ""}</TextStyle>

            <Caption>{description}</Caption>

            <br />
            {isDestination && (
              <>
                <Caption>{`${cms("label.destination")}: ${(destination && destination.label) || ""}`}</Caption>
                <Caption>{`Province: ${province ? province.label : "ALL"}`}</Caption>
              </>
            )}
            {isProduct && product && (
              <Caption>{`${cms("label.product")}: ${(product && product.label) || ""}`}</Caption>
            )}
            <Caption>{`${cms("label.priceType")}: ${priceTypeText}`}</Caption>
            <Caption>{`${cms("label.cost")}: ${moneyFormat} ${isFreeOption ? "0" : price}`}</Caption>
            <Caption>
              {`${cms("label.shipping")}: ${isShippingDisabled ? cms("label.disabled") : cms("label.enabled")}`}
            </Caption>
            {createdAt && (
              <Caption>
                {`Created At: ${baseHelper.formatDate(createdAt)}`}
              </Caption>
            )}
            {updatedAt && (
              <Caption>
                 {`Last updated At: ${baseHelper.formatDate(updatedAt)}`}
              </Caption>
            )}
          </Stack.Item>

          <Actions actions={shortcutActions} />
        </Stack>
      </div>
    </ResourceList.Item>
  );
};
RuleItem.propTypes = ruleItemProp.type;
export default RuleItem;
